define('views/content/distributors',['require','views/base/list_page_view','views/components/distributor/distributors','collections/distributors','text!templates/content/distributors.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var ResellersView = require('views/components/distributor/distributors');
    var DistributorsCollection = require('collections/distributors');

    var temp = require("text!templates/content/distributors.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'distributor-page',
        titleKey: 'distributors',

        setCollection: function () {
            this.collection = new DistributorsCollection();
        },

        onRender: function() {
            this.ListContainer.show(new ResellersView({
                collection: this.collection
            }));
        }

    });
});
